import { Button, Text } from '@bbl-digital/snorre'
import { IconClose } from '@bbl-digital/snorre-v2'
import { TooltipRenderProps } from 'react-joyride'
import { useAppDispatch } from 'shared/store/store'
import { GUIDE_COMPLETED_REQUESTED } from 'shared/store/guides/actionTypes'
import { SKIP_ALL_GUIDES } from '../../constants/guides'
import {
  BigTooltipBody,
  CloseWrapper,
  HeaderWrapper,
  TooltipContent,
  TooltipFooter,
} from './styles'

const GuideModal = ({
  continuous,
  index,
  size,
  step,
  closeProps,
  primaryProps,
  tooltipProps,
}: TooltipRenderProps) => {
  const dispatch = useAppDispatch()

  const skipAll = () => {
    dispatch({
      type: GUIDE_COMPLETED_REQUESTED,
      payload: SKIP_ALL_GUIDES,
    })
  }

  return (
    <BigTooltipBody {...tooltipProps} padding={step.title ? '1.5em' : '2em'}>
      {!step.title && (
        <CloseWrapper>
          <Button nostyle {...closeProps}>
            <div className="text-black">
              <IconClose />
            </div>
          </Button>
        </CloseWrapper>
      )}
      {step.title && (
        <HeaderWrapper>
          <Text bold>{step.title}</Text>
        </HeaderWrapper>
      )}
      <TooltipContent>{step.content}</TooltipContent>
      <TooltipFooter>
        <Button
          nostyle
          onClick={skipAll}
          trackingName="Felles"
          trackingEvent="Guide: Ikke nå"
        >
          Ikke nå
        </Button>
        {continuous && index + 1 < size && (
          <Button
            {...primaryProps}
            small={!!step.title}
            trackingName="Felles"
            trackingEvent="Guide: Neste"
          >
            Neste
          </Button>
        )}
        {continuous && index + 1 === size && (
          <Button
            {...primaryProps}
            small={!!step.title}
            trackingName="Felles"
            trackingEvent="Guide: Lukk"
          >
            Lukk
          </Button>
        )}
        {!continuous && (
          <Button
            {...closeProps}
            small={!!step.title}
            trackingName="Felles"
            trackingEvent="Guide: Lukk"
          >
            Lukk
          </Button>
        )}
      </TooltipFooter>
    </BigTooltipBody>
  )
}

export default GuideModal
